<template>
  <span>
    <template v-for="(item, index) in items">
      <v-list-item :key="item._id" class="pr-0 pl-0">
        <v-list-item-avatar class="mr-1" size="75" tile>
          <v-img
            :src="item.product_image_link || defaultImage"
            v-on:error="item.product_image_link = defaultImage"
          ></v-img>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-action-text class="pt-0" style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden">
            <span class="font-weight-bold">{{ item.product_title }}</span>
          </v-list-item-action-text>
          <v-list-item-action-text v-if="item.product_sku">
            <span class="font-weight-bold">{{ $t('product.sku') }}:</span>
            {{ item.product_sku }}
          </v-list-item-action-text>
          <v-list-item-action-text v-if="item.barcode || item.product_ean">
            <span class="font-weight-bold">{{ $t('product.barcode') }}:</span>
            {{ item.barcode || item.product_ean | formatBarCode() }}
          </v-list-item-action-text>
          <v-list-item-action-text v-if="item.product_size">
            <span class="font-weight-bold">{{ $t('product.size') }}:</span>
            {{ item.product_size }}
          </v-list-item-action-text>
          <v-list-item-action-text v-if="item.product_color">
            <span class="font-weight-bold">{{ $t('product.color') }}:</span>
            {{ item.product_color }}
          </v-list-item-action-text>
          <v-list-item-action-text>
            <span class="font-weight-bold">
              {{ $t('product.price') }}:
              <del v-if="item.product_default_price && item.product_default_price > item.product_sale_price">
                <span v-if="isReturnCreation">{{ item.product_default_price }} {{ currency.code }}</span>
                <span v-else>{{ item.product_default_price | formatPrice(currency) }} {{ currency.code }}</span>
              </del>
            </span>
            <span v-if="isReturnCreation">{{ item.product_sale_price }}</span>
            <span v-else>{{ item.product_sale_price | formatPrice(currency) }}</span>
            {{ currency.code }}
          </v-list-item-action-text>
          <v-list-item-action-text v-if="!isReturnCreation && item.return_reason">
            {{ $t('return.returnReason') }}:
            {{ item.custom_return_reason ? item.custom_return_reason : getReturnReasonTranslation(item.return_reason) }}
          </v-list-item-action-text>
          <v-list-item-action-text v-if="!isReturnCreation && item.external_return_reasons.length">
            {{ $t('return.returnReceiptReason') }}: {{ item.external_return_reasons.join(',') }}
          </v-list-item-action-text>
          <v-list-item-action-text v-if="isReturnCreation">
            {{ $t('return.maxReturnableQuantity') }}:
            <span v-if="item.is_returnable === false">0</span>
            <span v-else>{{ item.validated_quantity }}</span>
          </v-list-item-action-text>
          <v-list-item-action-text v-else>
            {{ $t('return.returnedQuantity') }}: {{ item.return_quantity }}
          </v-list-item-action-text>
          <v-list-item-action-text
            v-if="item.returned_quantity != undefined && returnStatus != 'waiting_products_receipt'"
          >
            {{ $t('return.receivedQuantity') }}: {{ item.returned_quantity }}
          </v-list-item-action-text>
          <v-list-item-action-text v-if="item.refunded_quantity != undefined && returnStatus === 'finished'">
            {{ $t('return.refundedQuantity') }}: {{ item.refunded_quantity }}
          </v-list-item-action-text>
          <v-list-item-action-text
            v-if="
              !isReturnCreation &&
              item.non_refund_reason &&
              !['products_received', 'products_partially_received'].includes(returnStatus)
            "
          >
            {{ $t('return.nonRefundReason') }}: {{ getNonRefundProductReasonTranslation(item.non_refund_reason) }}
          </v-list-item-action-text>
        </v-list-item-content>
      </v-list-item>
      <v-col :key="index" class="text-center pt-0 pl-0 pr-0">
        <v-col v-if="isReturnCreation">
          <v-row v-if="item.is_returnable === false" justify="center">
            <v-list-item-action-text>{{ $t('return.productNotReturnable') }}</v-list-item-action-text>
          </v-row>
          <span v-else>
            <v-row>
              <v-col class="pt-0 pb-0" cols="10" offset="1" offset-sm="2" sm="8">
                <v-select
                  v-model="item.return_quantity"
                  :items="getNbItems(item.validated_quantity)"
                  :label="$t('return.returnedQuantity')"
                  dense
                  hide-details
                  outlined
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="pt-0 pb-0" cols="10" offset="1" offset-sm="2" sm="8">
                <v-btn
                  :disabled="item.return_quantity < 1"
                  block
                  class="mt-2 mb-2"
                  color="primary"
                  depressed
                  small
                  tile
                  @click="openProductReturnReasonModal(item)"
                >
                  <span v-if="item.return_reason">{{ $t('return.modifyTheReason') }}</span>
                  <span v-else>{{ $t('return.indicateTheReason') }}</span>
                </v-btn>
              </v-col>
            </v-row>
            <v-list-item-action-text v-if="item.return_quantity > 0 && item.return_reason" class="pt-0 text-center">
              {{ $t('return.returnReason') }}:
              {{
                item.custom_return_reason ? item.custom_return_reason : getReturnReasonTranslation(item.return_reason)
              }}
            </v-list-item-action-text>
            <v-list-item-action-text
              v-if="item.return_quantity > 0 && !item.return_reason && isReturnCreation"
              class="red--text pb-0 pt-0"
            >
              {{ $t('return.errorConfirmation') }}
            </v-list-item-action-text>
          </span>
        </v-col>
        <v-col v-else-if="returnStatus === 'waiting_products_receipt'">
          <v-row>
            <v-col class="pt-0 pb-2" cols="10" offset="1" offset-sm="2" sm="8">
              <v-select
                v-model="item.returned_quantity"
                :items="getNbItems(item.return_quantity)"
                :label="$t('return.receivedQuantity')"
                dense
                hide-details
                outlined
              ></v-select>
            </v-col>
          </v-row>
          <v-list-item-action-text
            v-if="
              !isReturnCreation && returnStatus === 'waiting_products_receipt' && item.returned_quantity === undefined
            "
            class="red--text pb-0 pt-0"
          >
            {{ $t('return.errorReceivedQuantity') }}
          </v-list-item-action-text>
        </v-col>
        <v-col v-else-if="['products_received', 'products_partially_received'].includes(returnStatus)">
          <v-row>
            <v-col class="pt-0 pb-2" cols="10" offset="1" offset-sm="2" sm="8">
              <v-select
                v-model="item.refunded_quantity"
                :disabled="!item.returned_quantity"
                :items="getNbItems(item.returned_quantity)"
                :label="$t('return.quantityToRefund')"
                dense
                hide-details
                outlined
              />
              <v-btn
                v-if="item.refunded_quantity !== item.returned_quantity"
                :disabled="item.returned_quantity === 0"
                block
                class="mt-2 mb-2"
                color="primary"
                depressed
                tile
                @click="openNonRefundProductReason(item)"
              >
                <span v-if="item.non_refund_reason">{{ $t('return.modifyTheReason') }}</span>
                <span v-else>{{ $t('return.indicateTheReason') }}</span>
              </v-btn>
              <v-card-text
                v-if="
                  (item.refunded_quantity === 0 || item.refunded_quantity < item.returned_quantity) &&
                  item.non_refund_reason
                "
                class="pt-0 text-center"
              >
                {{ getNonRefundProductReasonTranslation(item.non_refund_reason) }}
              </v-card-text>
            </v-col>
          </v-row>
          <v-list-item-action-text
            v-if="
              !isReturnCreation &&
              ['products_received', 'products_partially_received'].includes(returnStatus) &&
              item.refunded_quantity !== item.returned_quantity &&
              !item.non_refund_reason
            "
            class="red--text pb-0 pt-0"
          >
            {{ $t('return.errorNonRefund') }}
          </v-list-item-action-text>
        </v-col>
        <v-col v-else-if="returnStatus === 'waiting'">
          <v-row>
            <v-col class="pt-0 pb-2" cols="10" offset="1" offset-sm="2" sm="8">
              <v-select
                v-model="item.approved_quantity"
                :items="getNbItems(item.return_quantity)"
                :label="$t('return.quantityToApprove')"
                dense
                hide-details
                outlined
              />
            </v-col>
          </v-row>
          <v-list-item-action-text
            v-if="
              !isReturnCreation &&
              ['products_received', 'products_partially_received'].includes(returnStatus) &&
              item.refunded_quantity !== item.returned_quantity &&
              !item.non_refund_reason
            "
            class="red--text pb-0 pt-0"
          >
            {{ $t('return.errorNonRefund') }}
          </v-list-item-action-text>
        </v-col>
        <v-divider v-if="index != items.length - 1" />
      </v-col>
    </template>
    <product-return-reason-dialog
      v-if="dialogProductReturnReason"
      v-model="dialogProductReturnReason"
      :choices="returnReasons"
      :introductionSentence="$t('return.returnReasonText')"
      :previousReason="targetItem.return_reason"
      :title="$t('return.returnReason')"
      @close="closeProductReturnReasonModal"
      @confirm="validateReturnReason"
    ></product-return-reason-dialog>
    <product-non-refund-reason-dialog
      v-if="dialogNonRefundProductReason"
      v-model="dialogNonRefundProductReason"
      :choices="nonRefundProductReasons"
      :introductionSentence="$t('return.returnReasonText')"
      :previousReason="targetItem.non_refund_reason"
      :title="$t('return.nonRefundDialogTitle')"
      @close="closeNonRefundProductReason"
      @confirm="validateNonRefundProductReason"
    ></product-non-refund-reason-dialog>
  </span>
</template>

<script>
  import ProductReturnReasonDialog from '@/components/MultipleChoicesDialog.vue'
  import { mapState } from 'vuex'

  export default {
    name: 'productListMobile',
    components: {
      ProductReturnReasonDialog: ProductReturnReasonDialog,
      ProductNonRefundReasonDialog: ProductReturnReasonDialog,
    },
    data() {
      return {
        dialogCancelProduct: false,
        targetItem: undefined,
        defaultImage: require('@/assets/img/products/product_default.png'),
        returnReasons: [],
        nonRefundProductReasons: [],
        dialogProductReturnReason: false,
        dialogNonRefundProductReason: false,
      }
    },
    mounted() {
      this.setReasons()
    },
    computed: {
      ...mapState(['currentStore', 'isCustomerService', 'isDark', 'isAdmin']),
    },
    props: {
      items: {
        type: Array,
        required: true,
      },
      currency: {
        type: Object,
        default: function () {
          return {
            _id: '5e467e3d7734c550979ac90a',
            code: 'EUR',
            minor_unit: 2,
            name: 'Euro',
            numeric_code: 978,
            symbol: '&#8364;',
          }
        },
      },
      isReturnCreation: {
        type: Boolean,
        default: false,
      },
      returnStatus: {
        type: String,
      },
      displayItemCustomReturnReason: {
        type: Boolean,
        default: true,
      },
      itemReturnReasons: {
        type: Array,
        default: () => {
          return []
        }
      },
      itemNonRefundReasons: {
        type: Array,
        default: () => {
          return []
        }
      },
    },
    methods: {
      getReturnReasonTranslation(returnReasonValue) {
        let returnReason = this.returnReasons.find((returnReason) => returnReason.value == returnReasonValue)
        if (returnReason) {
          return returnReason.text
        } else return returnReasonValue
      },
      getNbItems(validatedQuantity) {
        // get validated_quantity of an item for select option
        let nbItems = [0]
        for (let i = 1; i <= validatedQuantity; i++) {
          nbItems.push(i)
        }
        return nbItems
      },
      openProductReturnReasonModal(item) {
        this.$emit('removeEventKeyDown')
        this.targetItem = item
        this.dialogProductReturnReason = true
      },
      validateReturnReason(productReturnReason) {
        if (
          !this.returnReasons.some((choice) => {
            return choice.value == productReturnReason
          })
        ) {
          this.$set(this.targetItem, 'return_reason', 'other')
          this.$set(this.targetItem, 'custom_return_reason', productReturnReason)
        } else {
          this.$set(this.targetItem, 'return_reason', productReturnReason)
        }
        this.closeProductReturnReasonModal()
      },
      closeProductReturnReasonModal() {
        this.$emit('addEventKeyDown')
        this.targetItem = undefined
        this.dialogProductReturnReason = false
      },
      openNonRefundProductReason(item) {
        this.$emit('removeEventKeyDown')
        this.targetItem = item
        this.dialogNonRefundProductReason = true
      },
      validateNonRefundProductReason(nonRefundProductReason) {
        this.$set(this.targetItem, 'non_refund_reason', nonRefundProductReason)
        this.closeNonRefundProductReason()
      },
      closeNonRefundProductReason() {
        this.targetItem = undefined
        this.dialogNonRefundProductReason = false
      },
      getNonRefundProductReasonTranslation(returnReasonValue) {
        const nonRefundProductReasonsTranslations = [
          ...this.nonRefundProductReasons,
          { text: this.$t('return.productsNotReceived'), value: 'products_not_received' },
        ]
        let returnReason = nonRefundProductReasonsTranslations.find(
          (returnReason) => returnReason.value == returnReasonValue
        )
        if (returnReason) {
          return returnReason.text
        } else return returnReasonValue
    },
    setReasons() {
      const itemNonRefundReasonsTranslations = [
        { text: this.$t("return.incompleteProduct"), value: "incomplete_product" },
        { text: this.$t("return.damagedProduct"), value: "damaged_product" },
        { text: this.$t("return.other"), value: "other" }
      ]
      if(Array.isArray(this.itemNonRefundReasons)) {
        this.nonRefundProductReasons = []
        for (const nonRefundReason of this.itemNonRefundReasons) {
          const translatedNonRefundReason = itemNonRefundReasonsTranslations.find(
              translatedNonRefundReason => { return nonRefundReason === translatedNonRefundReason.value }
          )
          if(translatedNonRefundReason) {
            this.nonRefundProductReasons.push(translatedNonRefundReason)
          } else {
            this.nonRefundProductReasons.push({ text: nonRefundReason, value: nonRefundReason })
          }
        }
      } else {
        this.nonRefundProductReasons = itemNonRefundReasonsTranslations
      }

      this.nonRefundProductReasons.push({ text: this.$t('return.other'), value: 'other' })

      const itemReturnReasonsTranslations = [
        { text: this.$t("return.styleDoesNotSuitMe"), value: "style_does_not_suit_me" },
        { text: this.$t("return.productTooBig"), value: "product_too_big" },
        { text: this.$t("return.productTooSmall"), value: "product_too_small" },
        { text: this.$t("return.productNotCorrespondingToThePhoto"), value: "product_not_corresponding_to_the_photo" },
        { text: this.$t("return.lateDelivery"), value: "late_delivery" },
        { text: this.$t("return.disappointingQuality"), value: "disappointing_quality" },
        { text: this.$t("return.severalSizesOrdered"), value: "several_sizes_ordered" },
        { text: this.$t("return.defectiveProduct"), value: "defective_product" },
        { text: this.$t("return.customerNoShow"), value: "customer_no_show" },
        { text: this.$t("return.wrongProductReceived"), value: "wrong_product_received" }
      ]
      if(Array.isArray(this.itemReturnReasons)) {
        this.returnReasons = []
        for (const itemReturnReason of this.itemReturnReasons) {
          const translatedReturnReason = itemReturnReasonsTranslations.find(
              translatedReturnReason => { return itemReturnReason === translatedReturnReason.value }
          )
          if(translatedReturnReason) {
            this.returnReasons.push(translatedReturnReason)
          } else {
            this.returnReasons.push({ text: itemReturnReason, value: itemReturnReason })
          }
        }
      } else {
        this.returnReasons = itemReturnReasonsTranslations
      }
      if(this.displayItemCustomReturnReason){
        this.returnReasons.push({ text: this.$t('return.other'), value: 'other' })
      }
    }
  },
}
</script>

<style scoped>
  .isScanned {
    color: green !important;
  }

  div >>> div > .list-item-action-text-mobile {
    white-space: break-spaces;
    max-width: 75px;
  }
</style>
